var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.0336181,8.09438189 C17.3464222,7.78157781 17.3496602,7.27766024 17.036,6.964 L17.036,6.964 C16.7245114,6.6525114 16.2187527,6.6532473 15.9056181,6.96638189 L12,10.872 L8.09438189,6.96638189 C7.78157781,6.65357781 7.27766024,6.65033976 6.964,6.964 L6.964,6.964 C6.6525114,7.2754886 6.6532473,7.7812473 6.96638189,8.09438189 L10.872,12 L6.96638189,15.9056181 C6.65357781,16.2184222 6.65033976,16.7223398 6.964,17.036 L6.964,17.036 C7.2754886,17.3474886 7.7812473,17.3467527 8.09438189,17.0336181 L12,13.128 L15.9056181,17.0336181 C16.2184222,17.3464222 16.7223398,17.3496602 17.036,17.036 L17.036,17.036 C17.3474886,16.7245114 17.3467527,16.2187527 17.0336181,15.9056181 L13.128,12 L17.0336181,8.09438189 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03.-Icons/ic_close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon",
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.8299a3aa237fe30aee6469a8749289a3.svg";
export { ForwardRef as ReactComponent };